import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin); 

import { replaceContent, isVisible } from "../../utils/html";

export default class Archive {
  constructor(el) {
    this.el = el;

    this.state = false;

    this.timeout = false;

    this.elms = {
      pages: this.el.querySelectorAll("[data-archive-page]"),
      loading: this.el.querySelectorAll("[data-archive-loading]"),
      filters: document.querySelector("[data-archive-filters]"), 
    }; 

    this.init();
  }

  init() {
   
    //pagination
    if (this.elms.pages) {
      this.elms.pages.forEach((el) => {
        el.addEventListener("click", (e) => this.changePage(e));
      });
    } 

    //filters  
    if (this.elms.filters) {
       this.initFilters(); 
    } 
 
    //after init
    this.afterInit();
  }

  afterInit() {}


  initFilters($first = true){
    if (this.elms.filters) {  
  
      this.filters = {
        el: this.elms.filters, 
        all : [],
        radio: this.elms.filters.querySelectorAll("[data-filter-radio]"), 
        multiselect: this.elms.filters.querySelectorAll("[data-filter-multiselect]"), 
      }   

      if (this.filters.radio) {  
        this.initFiltersRadio(this.filters.radio); 
      }

      if (this.filters.multiselect) {   
        this.initFiltersMultiselect(this.filters.multiselect, $first); 
      }  
    }
  } 


  initFiltersRadio(filters){

    if (filters) {     
      filters.forEach((el) => {

        const inputs = el.querySelectorAll('[data-filter-input]');

        inputs.forEach((input) => { 
          input.addEventListener("change", () => this.changeEvent(input));
          const filter = { 
            el: el,
            input: input,
            name: input.name,
            type: el.dataset.filterType,
          }  
          this.filters.all.push(filter);
        }); 

      }); 
    }  

  }

  initFiltersMultiselect(filters){

    filters.forEach((el) => { 
  
      const input = el.querySelector('[data-filter-input]');
      const config = JSON.parse(el.dataset.filterMultiselect); 
      const multiselect = multipleSelect( input, {
        ...config, 
        showOkButton : true, 
        single : false,  
        maxHeight : 5, 
        maxHeightUnit : 'row', 
        minimumCountSelected : 2,  
        filterByDataLength : 10,
        filterAcceptOnEnter : true,
        filterPlaceholder: 'Rechercher', 
        countSelectedText : `${config.title} #`,  
        onChange() { 
          const button = el.querySelector('.ms-choice span');
          const count = multiselect.getSelects().length;  
          if(count > 2){
            button.innerHTML = `${config.title} <span class="count">${count}</span>`;
          } 
        }, 
      }); 
    
      const filter = { 
        el: el,
        title: config.title,
        input: input,
        name: input.name,
        type: el.dataset.filterType,
        multiselect: multiselect,
        selectAll : document.querySelector(`[data-name="selectAll${input.name}"]`), 
      }   
      const multiselectActiveFilters = JSON.parse(el.dataset.multiselectActive);
  
      if( multiselectActiveFilters && multiselectActiveFilters.length > 0){ 
        multiselect.setSelects(multiselectActiveFilters, 'value');
      }else{
        multiselect.checkAll();
      } 
      
      input.addEventListener("change", () => this.setFilters());
      
      this.filters.all.push(filter);

    });

  }

  setFilters(){ 
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.setFirstPage();  
      this.ajaxProcess(); 
    }, 200) 
  }

  changePage(e) {
    e.preventDefault();

    if (e.target.dataset.archivePage == "next") {
      this.setNextPage();
    } else if (e.target.dataset.archivePage == "prev") {
      this.setPrevPage();
    } else {
      this.setPage(e.target.dataset.archivePage);
    }

    this.ajaxProcess();
  }

  changeEvent(item) {  
 
    const filter = item.closest("[data-filter-radio]");
    const filterItem = item.closest("[data-filter-item]");

    if (item.type == "radio") {
      filter.querySelectorAll("[data-filter-item]").forEach((el) => {
        el.classList.remove("is-active");
      });

      filterItem.classList.add("is-active");
    } else if (item.type == "checkbox") {
      filterItem.classList.toggle("is-active");
    }

    this.setFilters();
  }

  getConfig() {
    this.config = {
      more_config: this.el.querySelector('input[name="more_config"]') ? JSON.parse(this.el.querySelector('input[name="more_config"]').value) : '',
      new_url: this.el.querySelector('input[name="new_url"]') ? true : false,
      listing_type: this.el.querySelector('input[name="listing_type"]') ? this.el.querySelector('input[name="listing_type"]').value : "",
      posts_per_page: this.el.querySelector('input[name="posts_per_page"]') ? this.el.querySelector('input[name="posts_per_page"]').value : "",
      post_type: this.el.querySelector('input[name="post_type"]') ? this.el.querySelector('input[name="post_type"]').value : "",
      paged: this.el.querySelector('input[name="paged"]') ? this.el.querySelector('input[name="paged"]').value : "",
      last_page: this.el.querySelector('input[name="last_page"]') ? this.el.querySelector('input[name="last_page"]').value : "",
      tax_query: this.el.querySelector('input[name="tax_query"]') ? JSON.parse(this.el.querySelector('input[name="tax_query"]').value) : '',
      meta_query: this.el.querySelector('input[name="meta_query"]') ? JSON.parse(this.el.querySelector('input[name="meta_query"]').value) : '', 
    }

    //filters
    if (this.filters) { 

      let taxonomies = {}; 
      let meta_queries = {};
      let custom_filters = {};

       this.filters.all.forEach((filter) => {   
          
        if ( isVisible(filter.el) ) { 

          //multiselect 
          if( filter.multiselect ){   
             
            if(!filter.selectAll.checked){ 
              if( filter.type == 'taxonomy' ){
                taxonomies[filter.input.name] = filter.multiselect.getSelects(); 
              }else if( filter.type == 'meta_query' ){
                meta_queries[filter.input.name] = filter.multiselect.getSelects(); 
              }else{
                custom_filters[filter.input.name] = filter.multiselect.getSelects(); 
              }
            } 
             
          }else{
            
            //input radio || select
            if ( isVisible(filter.input) ) {  

              const tag = filter.input.tagName.toLowerCase(); 
              if( ( tag == 'input' && filter.input.checked ) || ( tag == 'select' && filter.input.value ) ){
 
                if( filter.type == 'taxonomy' ){
                  if (!(filter.input.name in taxonomies)) {
                    taxonomies[filter.input.name] = [];
                  }
                  taxonomies[filter.input.name].push(filter.input.value);
                }else if( filter.type == 'meta_query' ){
                  if (!(filter.input.name in meta_queries)) {
                    meta_queries[filter.input.name] = [];
                  }
                  meta_queries[filter.input.name].push(filter.input.value); 
                }else{
                  if (!(filter.input.name in custom_filters)) {
                    custom_filters[filter.input.name] = [];
                  }
                  custom_filters[filter.input.name].push(filter.input.value);
                } 
              }   
            }
          }
        } 
      }); 
 
      this.config.taxonomies = taxonomies; 
      this.config.meta_queries = meta_queries; 
      this.config.custom_filters = custom_filters; 
    }
  }

  ajaxProcess() {
    clearTimeout(this.timeout);

    this.getConfig();  

    const formData = new FormData();
    formData.append("action", "hwc_ajax_archive");
    formData.append("config", JSON.stringify(this.config));

    this.state = true;
    this.el.dataset.loading = true;
    gsap.to(this.elms.loading, { autoAlpha: 1, duration: 0.3 });

    fetch(hwc_vars.ajax_url, {
      method: "POST",
      body: formData,
    })
    .then((res) => res.text())
    .then((response) => {
      this.timeout = setTimeout(() => {
        if (!response) return;

        let data;

        try {
          data = JSON.parse(response);
        } catch (e) {
          console.error("Erreur de parsing JSON");
          return true;
        }

        if (data.html && this.el.querySelector("[data-archive-listing]")) {

          replaceContent(data.html, "[data-archive-listing]");

          this.el.querySelectorAll("[data-archive-page]").forEach((el) => {
            el.addEventListener("click", (e) => this.changePage(e));
          });
        }

        this.setLastPage(data.last_page);
        this.setTotalPosts(data.total_posts);

        this.afterAjaxProcess(); 

        if (data.new_url) {
          window.history.pushState(this.config, "", data.new_url);
        }

        this.state = false;
        this.el.dataset.loading = false;
        gsap.to(this.elms.loading, { autoAlpha: 0, duration: 0.3 });

      }, 500);
    })
    .catch((error) => {
      console.error("Erreur AJAX :", error);
      this.state = false;
      this.el.dataset.loading = false;
      gsap.to(this.elms.loading, { autoAlpha: 0, duration: 0.3 });
    });
  }

  afterAjaxProcess() {} 

  setFirstPage() {
    if (this.el.querySelector('input[name="paged"]')) {
      this.el.querySelector('input[name="paged"]').value = 1;
    }
  }

  setTotalPosts(value) {
    if (this.el.querySelector('input[name="total_posts"]')) {
      this.el.querySelector('input[name="total_posts"]').value = value;
    }
    
    if(document.querySelector('[data-archive-count]')) { 
      document.querySelector('[data-archive-count]').textContent = value;
    }
  }

  setLastPage(value) {
    if (this.el.querySelector('input[name="last_page"]')) {
      this.el.querySelector('input[name="last_page"]').value = value;
    }
  }

  setPage(value) {
    if (this.el.querySelector('input[name="paged"]')) {
      this.el.querySelector('input[name="paged"]').value = value;
    }
  }

  setPrevPage() {
    if (this.el.querySelector('input[name="paged"]')) {
      this.el.querySelector('input[name="paged"]').value =
        this.getCurrentPage() - 1;
    }
  }

  setNextPage() {
    if (this.el.querySelector('input[name="paged"]')) {
      this.el.querySelector('input[name="paged"]').value =
        this.getCurrentPage() + 1;
    }
  }

  getCurrentPage() {
    if (this.el.querySelector('input[name="paged"]')) {
      return Number(this.el.querySelector('input[name="paged"]').value);
    }
  }

  getLastPage() {
    if (this.el.querySelector('input[name="last_page"]')) {
      return Number(this.el.querySelector('input[name="last_page"]').value);
    }
  }

  isLastPage() {
    return this.getLastPage() == this.getCurrentPage();
  }

  getTotalPosts() {
    if (this.el.querySelector('input[name="total_posts"]')) {
      return Number(this.el.querySelector('input[name="total_posts"]').value);
    }
  }
}
